import date from 'quasar/src/utils/date.js';

export default {
    install(Vue) {
        Vue.filter('currency', function (value) {
            return `$${parseFloat(value).toFixed(2)}`
        })
        Vue.filter('date', function (value) {
            return date.formatDate(value, 'YYYY/MM/DD')
        })
        Vue.filter('toLocaleString', function (value) {
            return value.toLocaleString()
        })
        Vue.filter('toProperCase', function (value) {
            return value.replace(/\w\S*/g, function (txt) { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(); });
        })
        Vue.filter('toLowerCase', function (value) {
            return value.toLowerCase()
        })
    }
};
